import {AmCharts} from 'amcharts';
import {EntitlementMap, ErrorCodeMap} from '../domain/TbMaps';
import {clearCookie, getCookie, setCookie} from '../utils/cookies';
import {error} from '../utils/log';
import clear = AmCharts.clear;
import {EventBus, Messages} from './EventBus';

/*interface Token {
    TOKEN: string;
    ErrorCode?: number;
    MarketDataEntitlementTypeId: number;
    __type?:any;
}*/

interface Token {
    Payload: string;
    ResponseCode?: number;
    // MarketDataEntitlementTypeId: number;
    __type?: any;
}

declare var TradingBlockAjaxEndpoint: any;
// declare var TradingblockApiEndpointUrl:string;
const  StagTradingblockApiEndpointUrl = 'https://staging.tradingblock.com/RestHub/';
const  ProdTradingblockApiEndpointUrl = 'https://api3.tradingblock.com/RestHub/';

 // const LOGIN_HOST= 'http://stockforecast.tradespoon.com';
 // const LOGIN_HOST= 'http://stockforecast.velvetech.com';

// const LOGIN_HOST= LOGIN_HOST;
export default class AuthService {

    private static service: AuthService;
    private token: Token | null;

    private static live: boolean = false;

    private static setLive(v: boolean) {
        AuthService.live = v;
    }

    public static loadPreviousLive() {
        const mode = getCookie('LastMode');
        if (mode) {
            AuthService.live = mode === 'live' ? true : false;
        }

        return AuthService.live;
    }
    public checkAgreement(): boolean {
        return getCookie('api_agree') !== 'true';
    }

    public setAgreement() {
        setCookie('api_agree', 'true');
    }

    public checkCookie(onLoginSuccess: (s: string) => void) {
        const cookie =  getCookie('TB_KEY');
        if (cookie && cookie !== 'false') {
            this.token = JSON.parse(cookie);

            const str = 'Welcome again ' + getCookie('USERNAME');
            // if (EntitlementMap[this.token!.MarketDataEntitlementTypeId]) {
            //     str += '<br/>You are registered as ' + EntitlementMap[this.token!.MarketDataEntitlementTypeId];
            // }
            onLoginSuccess(str);

        }
    }

    public authenticated() {

        return !!this.getTOKEN();
    }

    public static getUrl() {
        if (AuthService.live) {
            return ProdTradingblockApiEndpointUrl;
        } else {
            return StagTradingblockApiEndpointUrl;
        }
    }

    public getTOKEN(): string | null {
        const cookie =  getCookie('TB_KEY');
        if (cookie && cookie !== 'false') { return JSON.parse(cookie); }
        if (StagTradingblockApiEndpointUrl.indexOf('localhost') > -1) { return ''; }
        if (ProdTradingblockApiEndpointUrl.indexOf('localhost') > -1) { return ''; }
        if (!this.token) {
            return null;
        } else { return this.token.Payload; }
    }
    /*
    getAccountParams() {
        if (!this.accountCtrl) return {};
        return this.accountCtrl.getAccountParams();
    }
    getAccountName() {
        if (!this.accountCtrl) return null;
        return this.accountCtrl.getAccountName();
    }
    getSubAccountName() {
        if (!this.accountCtrl) return null;
        return this.accountCtrl.getSubAccountName();
    }
    */

    public checkResponse(tradeBlockName: string, response: any, sucCb: (rsp: any)
      => void, failCb: (str: string) => void) {
        if (response.error || !response.value) {
            clearCookie('USERNAME');
            this.token = null;
            // this.accountCtrl = null;
            return;
        }
        if (response.value.ResponseCode !== 0) {
            clearCookie('USERNAME');
            this.token = null;
            // this.accountCtrl = null;
            const str = ErrorCodeMap[response.value.ResponseCode];
            failCb(str);
        } else if (response.value.ResponseCode === 0) {
            this.token = response.value;
            // if ajax has types in , remove them
            delete this.token!.__type;
            setCookie('TB_KEY', JSON.stringify(this.token!.Payload), new Date(new Date().getTime() + 3600 * 4 * 1000));
            setCookie('USERNAME', tradeBlockName);
            setCookie('LastMode', AuthService.live ? 'live' : 'virtual');
            sucCb(response.value);
        } else {
            clearCookie('USERNAME');
            this.token = null;
            // this.accountCtrl = null;

            failCb('unknown error');
        }
    }
    public login(tradeBlockName: string, tradeBlockPassword: string, live: boolean,  sucCb: (rsp: any)
      => void, failCb: (str: string) => void, ajxCb?: () => void) {
        AuthService.setLive(live);
        if (process.env.VUE_APP_SFT_ACCESS) {
            TradingBlockAjaxEndpoint.LoginAsync(tradeBlockName, tradeBlockPassword, AuthService.live, (response: any) => {
                if (ajxCb) { ajxCb(); }
                this.checkResponse(tradeBlockName, response, sucCb, failCb);
            });
        } else {
            ($.ajax as any)({
                type: 'POST',
                cashe: false,
                url: window.ApplicationPath + '/WebServices/WebService.asmx/LoginAsync',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                crossDomain: true,
                data: '{\"username\": \"' + tradeBlockName + '\", \"password\": \"' + tradeBlockPassword + '\", \"live\": ' + AuthService.live + '}',
                success: (response: {d: Token}, textStatus: string, jqXHR: any) => {

                    if (!response.d) {
                        this.token = null;
                        clearCookie('USERNAME');
                        return;
                    }
                    const str = ErrorCodeMap[response.d.ResponseCode!];
                    if (response.d.ResponseCode !== 0) {
                        this.token = null;
                        clearCookie('USERNAME');
                        failCb(str);
                    } else if (response.d.ResponseCode === 0) {
                        this.token = response.d;
                        delete this.token!.__type;
                        setCookie('TB_KEY', JSON.stringify(this.token.Payload), new Date(new Date().getTime() + 3600 * 4 * 1000));
                        setCookie('USERNAME', tradeBlockName);
                        setCookie('LastMode', AuthService.live ? 'live' : 'virtual');

                        sucCb(response.d);
                    } else {
                        this.token = null;
                        clearCookie('USERNAME');
                        failCb('An unexpected error occurred');
                    }
                },
                error: (data: any, textStatus: any, jqXHR: any) => {
                    error.log(textStatus);
                },
            });

        }
    }

    public static afterLogout() {
        clearCookie('TB_KEY');
        clearCookie('LastAccountId');
        clearCookie('LastSubAccountId');
        clearCookie('LastMode');

        // EventBus.$emit(Messages.logout);
    }
    public logout(sucCb: () => void, failCb: (s: string) => void, ajxCb?: () => void) {
        if (process.env.VUE_APP_SFT_ACCESS) {
            TradingBlockAjaxEndpoint.Logout(this.getTOKEN(), AuthService.live, (response: any) => {
                // this.accountCtrl = null;
                if (ajxCb) { ajxCb(); }
                this.token = null;
                AuthService.afterLogout();
                if (response.error) {
                    return failCb(ErrorCodeMap[response.error]);
                }
                this.token = null;

                return sucCb();
            });
        } else {
            ($.ajax as any)({
                type: 'POST',
                cashe: false,
                url:  window.ApplicationPath + '/WebServices/WebService.asmx/Logout',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                crossDomain: true,
                data: '{\'token\': \'' + this.getTOKEN() + '\', \'live\':' + AuthService.live + '}',
                success: (response: {d: Token}, textStatus: any, jqXHR: any) => {
                  AuthService.afterLogout();
                    // if (!response.d) {
                    //     failCb('empty d');
                    // }

                    this.token = null;
                    sucCb();
                },
                error: (data: any, textStatus: any, jqXHR: any) => {
                    AuthService.afterLogout();
                    error.log(textStatus);
                },
            });
        }
    }
}
